const adaptReaction = (data: ICommentReaction): CommentReaction => ({
	reaction: data.reaction,
	count: data.count ?? 0,
	userReacted: data.user_reacted ?? false
});

const adaptReply = (data: ICommentReply): CommentReply => ({
	id: data.id,
	socialPost: data.social_post,
	body: data.body,
	user: data.user,
	userName: data.user_name ?? null,
	commentDate: data.comment_date,
	reactions: (data.reactions ?? []).map(adaptReaction),
	impersonatedBy: data.impersonated_by
		? {
				userId: data.impersonated_by.user_id,
				firstName: data.impersonated_by.first_name,
				lastName: data.impersonated_by.last_name,
				avatarUrl: data.impersonated_by.avatar_url
			}
		: null
});

export const adaptComment = (data: IComment): SocialComment => ({
	id: data.id,
	socialPost: data.social_post,
	body: data.body,
	user: data.user,
	userName: data.user_name ?? null,
	parentComment: data.parent_comment,
	commentDate: data.comment_date,
	commentReplies: (data.comment_replies ?? []).map(adaptReply),
	reactions: (data.reactions ?? []).map(adaptReaction),
	impersonatedBy: data.impersonated_by
		? {
				userId: data.impersonated_by.user_id,
				firstName: data.impersonated_by.first_name,
				lastName: data.impersonated_by.last_name,
				avatarUrl: data.impersonated_by.avatar_url
			}
		: null
});

export const adaptComments = (data: IComment[]): SocialComment[] => {
	return data.map(adaptComment);
};
